import React, { useEffect, useRef, useState } from 'react'
import { IFieldInput } from '../../../../types'

const FieldInput: React.FC<IFieldInput> = ({name, type, inputHandler, value, placeholder, min, max}) => {
  
  return (
    <input
          name={name}
          className="calculator__input__single"
          type={type}
          onChange={(e) => inputHandler(e)}
          value={value}
          placeholder={placeholder}
          autoComplete="off"
          min={min}
          max={max}
        />
  );
}

export default FieldInput
